import { isRouteLocked } from './Onboarding/providerJourney';

// What is left of the old profile setup guide. Its banner ("Complete Your
// Profile 0/5 · Continue") and its five-section rule are gone: the journey
// (Onboarding/providerJourney.js) decides what is complete and what is next,
// and the profile walk asks it.

// The route guard and the Market Pulse lock ask this. It is the journey's
// lock rule: locked only while the profile is unfinished by the one-question
// walk AND by the old five-section bar, so nobody who already had access is
// locked out by the stricter walk (the journey nudges them instead).
export const hasIncompleteSections = (profile) => isRouteLocked(profile);
